import { AntDesign } from "@expo/vector-icons";
import * as Device from "expo-device";
import { router } from "expo-router";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Text, View, Linking, ScrollView, SafeAreaView } from "react-native";

import BodyImage from "@/assets/getready.svg";
import Logo from "@/assets/logo.svg";
import Copyright from "@/components/Copyright";
import Title from "@/components/Title";
import Button from "@/components/button/Button";
import ButtonLogout from "@/components/button/ButtonLogout";
import ButtonSmall from "@/components/button/ButtonSmall";
import { storage } from "@/context/storage";

export default function GetReady() {
  const [isDownloadPressed, setIsDownloadPressed] = useState(true);
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [isCorporationApplication, setIsCorporationApplication] =
    useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const applicationType = storage.getString("user.auth.applicationType");
    if (applicationType === "CORPORATION") {
      setIsCorporationApplication(true);
    }
  }, []);

  useEffect(() => {
    const fetchDeviceType = async () => {
      const deviceType = await Device.getDeviceTypeAsync();
      if (deviceType !== 3) {
        setIsMobileDevice(true);
      }
    };

    fetchDeviceType();
  }, []);

  const { handleSubmit } = useForm<FormData>({
    mode: "onChange",
  });

  const handleDownload = async () => {
    const url = "/beneficialowneragreement.pdf";
    const supported = await Linking.canOpenURL(url);

    if (supported) {
      await Linking.openURL(url);
      setIsDownloadPressed(false);
    }
  };

  const onSubmit = () => {
    const type = storage.getString("user.auth.applicationType");
    if (type === "INDIVIDUAL") {
      router.replace("/individual/name");
    } else if (type === "CORPORATION") {
      router.replace("/corporation/information");
    }
  };

  return (
    <SafeAreaView className="grow bg-white1 p-2">
      <View className="z-50 absolute top-0 right-0 m-8">
        <ButtonLogout />
      </View>
      <View className="items-center w-full h-full">
        <Logo className="m-2" />
        <View className="m-2">
          <Title text={t("onboarding/getready:title")} />
        </View>
        <View className="flex-grow items-center w-full">
          <Text className="text-darkergray text-base m-1">
            {t("onboarding/getready:advice")}
          </Text>
          {isMobileDevice && isCorporationApplication ? (
            <View className="flex-grow w-full items-center justify-center">
              <Text className="text-xl text-center my-4">
                {t("onboarding/getready:mobileadvice")}
              </Text>
              <AntDesign name="closecircle" size={50} color="red" />
            </View>
          ) : (
            <View className="flex-grow w-full items-center justify-center">
              <View className="items-center justify-center">
                <BodyImage width={280} height={220} className="m-4" />
              </View>
              {isCorporationApplication && (
                <View className="flex-col w-full items-center gap-4">
                  <Text className="text-xl text-darkergray text-center">
                    {t("onboarding/getready:corporationdownload")}
                  </Text>
                  <ButtonSmall
                    label={t("common:button.download")}
                    onClick={handleDownload}
                  />
                </View>
              )}
            </View>
          )}
        </View>
        <View className="justify-end items-center">
          <Button
            label={t("common:button.nextstep")}
            blocked={isCorporationApplication ? isDownloadPressed : false}
            onClick={handleSubmit(onSubmit)}
          />
          <Copyright />
        </View>
      </View>
    </SafeAreaView>
  );
}
